import { render, staticRenderFns } from "./VideoControl.vue?vue&type=template&id=066fda77&scoped=true"
import script from "./VideoControl.vue?vue&type=script&lang=js"
export * from "./VideoControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066fda77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066fda77')) {
      api.createRecord('066fda77', component.options)
    } else {
      api.reload('066fda77', component.options)
    }
    module.hot.accept("./VideoControl.vue?vue&type=template&id=066fda77&scoped=true", function () {
      api.rerender('066fda77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/VideoControl.vue"
export default component.exports